import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  // const { handleShowModal1 } = useGlobalContext();
  const highlights1 = [
    "Thane's Largest Township - A 104-acre integrated development",
    "40+ Lifestyle Amenities with a Grand Clubhouse",
    "1 & 2 BHK Spacious & Luxurious Homes",
  ];
  const highlights2 = [
    "Basement, Upper Ground & Podium Levels",
    "Under Construction Euro School a minute away",
    "Over 3500+ trees planted till date",
  ];
  return (
    <section class="section shadow-sm lazyloaded" id="overview">
      <div class="over1">
        <h1 class="d-block section-heading color-primary text-capitalize">
          {project} - Overview
        </h1>

        <p>
          Dosti Nest is an exclusive residential cluster within Dosti West
          County, Thane's most sought-after township. Featuring Dosti Heron,
          Dosti Dove, and Dosti Merlin, this development offers spacious 1 & 2
          BHK homes with smart layouts, modern interiors, and world-class
          amenities. The 104-acre township ensures a balanced lifestyle with
          lush green landscapes, premium infrastructure, and seamless
          connectivity to Mumbai and key business hubs.
          <br /> Designed for families, working professionals, and investors,
          Dosti Nest provides 40+ lifestyle amenities, excellent rental
          benefits, and an attractive 20:80 payment plan, making it a prime
          residential choice in Thane.
        </p>
      </div>
      <center>
        <h3 style={{ fontSize: "1.2rem" }} className="mt-3">
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy text-capitalize">
              <li>
                <span>Spacious 1 & 2 BHK Residences</span>
              </li>
              <li>
                <span>
                  Iconic high-rise 46-Storey Towers with premium architecture
                </span>
              </li>
              <li>
                <span>
                  Unmatched Investment Potential with high appreciation value
                </span>
              </li>
            </ul> */}

            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            {/* <ul className="whybuy">
              <li>
                <span>Smart layouts for modern families</span>
              </li>
              <li>
                <span>
                  Seamless Connectivity to EEH, Railway Station & Malls
                </span>
              </li>
              <li>
                <span>
                  Marvellous Amenities like Clubhouse, Swimming Pool & More
                </span>
              </li>
            </ul> */}
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        class="chat-btn btn btn-info micro-form-btn effetMoveGradient enqModal download_brochure"
        onClick={handleShowModal}
      >
        <span class="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
